import { Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "[viewMode2]",
})
export class ViewMode2Directive {
  constructor(public tpl: TemplateRef<any>) {}
}
